// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA9N-yoM3EwIAromkGAnEEDtYD1JrkSwtA",
  authDomain: "replay-96c2d.firebaseapp.com",
  databaseURL: "https://replay-96c2d-default-rtdb.firebaseio.com",
  projectId: "replay-96c2d",
  storageBucket: "replay-96c2d.appspot.com",
  messagingSenderId: "106216397502",
  appId: "1:106216397502:web:ba2c0d62e1300aab1c9cef",
  measurementId: "G-JWXRXFJPP3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app); // Make sure this is a named export

export default app; // This line exports the Firebase app instance